export default function getMachinesSalesAverageChartConfig(showAVGofAVG, setShowAVGofAVG, currentData, averageOfAverages, itemsPerPage, showMedianOfAVG, medianOfAVG) {
  return {
    indexAxis: "y",
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        // display: true,
        display: false,
        position: "bottom",
        labels: {
          generateLabels: () => {
            return [
              {
                text: "Średnia z sumy",
                fillStyle: "#FF7A00",
                strokeStyle: "#FF7A00",
                lineWidth: 2,
                hidden: !showAVGofAVG,
                index: 0,
              },
            ];
          },
          usePointStyle: true,
          pointStyle: "line",
        },
        onClick: () => setShowAVGofAVG(!showAVGofAVG),
      },
      tooltip: {
        callbacks: {
          title: () => "Sprzedaż dzienna (średnia) z ostatnich 30 dni, wliczając wszystkie dni tygodnia",
          label: (context) => {
            const label = context.dataset.label || "";
            const value = context.raw || 0;
            const index = context.dataIndex;
            const product = currentData[index];
            const count = product ? product.AverageIncomeCount || 0 : 0;
            const formattedValue = new Intl.NumberFormat("pl-PL", {
              style: "currency",
              currency: "PLN",
            }).format(value);
            return `${label} ${currentData[index].MachineFullName}: ${formattedValue} (${count} szt.)`;
          },
        },
      },
      title: {
        display: false,
      },
      annotation: {
        annotations: {
          averageLine: {
            display: showAVGofAVG,
            type: "line",
            xMin: averageOfAverages,
            xMax: averageOfAverages,
            borderColor: "#FF7A00",
            borderWidth: 4,
            label: {
              display: showAVGofAVG,
              content: `  ${new Intl.NumberFormat("pl-PL", {
                style: "currency",
                currency: "PLN",
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              }).format(averageOfAverages)}  `,
              position: "end",
              backgroundColor: "#FF7A00",
              color: "white",
              padding: 2,
              
            },
          },
          medianLine: {
            type: "line",
            display: showMedianOfAVG,
            xMin: medianOfAVG,
            xMax: medianOfAVG,
            borderColor: "#666A71",
            borderWidth: 4,
            label: {
              display: showMedianOfAVG,
              content: `  ${new Intl.NumberFormat("pl-PL", {
                style: "currency",
                currency: "PLN",
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              }).format(medianOfAVG)}  `,
              position: "end",
              backgroundColor: "#666A71",
              color: "white",
              padding: 2,
            },
          },
        },
      },
    },
    scales: {
      x: {
        position: "top",
        beginAtZero: true,
        title: {
          display: false,
        },
        ticks: {
          callback: (value) => {
            return new Intl.NumberFormat("pl-PL", {
              style: "currency",
              currency: "PLN",
              minimumFractionDigits: 0,
              maximumFractionDigits: 0,
            }).format(value);
          },
        },
        grid: {
          color: "rgba(0, 0, 0, 0.1)",
        },
      },
      y: {
        position: "left",
        title: {
          display: true,
        },
        ticks: {
          autoSkip: false,
          maxTicksLimit: itemsPerPage,
          align: "start",
          mirror: false, 
          padding: 5,    
          crossAlign: "near",
        },
        grid: {
          drawTicks: false,
        }
      },
    },

    hover: {
      mode: "nearest",
      intersect: true,
    },
    animation: {
      duration: 0,
    },
  }
}